const state = () => ({

});

const mutations = {

};

const actions = {
    event({ commit, dispatch }, data)
    {
        if (!data.type)return;

        if (data.type === "share")
        {
            if (!data.payload)
            {
                data.payload = [];
            }
            dispatch("fireEvent", { eventName: "share", payload: data.payload });
        }

        return;
    },

    fireEvent({ commit, state }, { eventName, payload })
    {
        window.dataLayer = window.dataLayer || [];
        const eventData = {
            event: "share",
            share: {
                payload: payload
            }
        };

        window.dataLayer.push(eventData);
    }
};

export default {
    state,
    actions,
    mutations
};
